export default __webpack_public_path__ + "static/media/LogoD.78671a00.jpg";